import { isBoolean } from "util";
import $ from 'jquery';
import J from "../../js/common.js";
import api from "../../js/apiconfig"; 
import common from "../../js/common.js";
var layui = window.layui;
export default {
    name: 'Root',
    props: {
        show: {
            type: Boolean,
            default: true,
            required: false,
            validator: function(value) {
                return isBoolean(value)
            }
        },
        showleft: {
            type: Boolean,
            default: true,
            required: false,
            validator: function(value) {
                return isBoolean(value)
            }
        }
    },
    data: function() {
        return {
            topMenu: [],
            onTopMenu: 0, //1级默认选中  默认不能为-1 否则会出现取左侧菜单时索引错误
            leftMenu: [],
            onLeftMenu: [-1, -1], //2级 ， 3级
            url: "",
            isSet: false,
            rightClass: "",
            imgBase: this.Api.imgBase,

            ShowHeadRight: true,

            //以下顶部右侧
            ShowNotice: true,
            CompanyMsg: {},
            empInfo: {
                head: "",
                empName: "未知",
                deptName: "未知"
            },
            // HeadLogo: "images/head/head-logo.png",
            CompanyLogo: "",
            ShowUpt: false,
            location: window.location,
            site: window.location.href.indexOf("/personal/") >= 0 ? "emp" : "hr"

        }
    },
    components: {

    },
    beforeCreate: function() {


        // 获取谷歌浏览器版本
        let getChromeVersion = function() {
            var arr = navigator.userAgent.split(' ');
            var chromeVersion = '';
            for (var i = 0; i < arr.length; i++) {
                if (/chrome/i.test(arr[i]))
                    chromeVersion = arr[i]
            }
            if (chromeVersion) {
                return Number(chromeVersion.split('/')[1].split('.')[0]);
            } else {
                return false;
            }
        }
        if (getChromeVersion()) {
            var version = getChromeVersion();
            console.log(version);
            if (version < 60) {
                alert('您使用的谷歌浏览器(chrome)版本过低，为了更好地体验请将浏览器升级到最新版本！');
            }
        }




        let IEVersion = function() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion == 7) {
                    return 7;
                } else if (fIEVersion == 8) {
                    return 8;
                } else if (fIEVersion == 9) {
                    return 9;
                } else if (fIEVersion == 10) {
                    return 10;
                } else {
                    return 6; //IE版本<=7
                }
            } else if (isEdge) {
                return 'edge'; //edge
            } else if (isIE11) {
                return 11; //IE11  
            } else {
                return -1; //不是ie浏览器
            }
        }

        let ie = IEVersion();
        //alert(ie);
        if (ie > 0 && ie < 10) {

            alert('您使用的IE浏览器（或IE内核）版本过低无法正常使用请更新至IE11或使用其他浏览器（Chrome、火狐等）；若您使用的是国产浏览器请将内核模式切换为极速模式。');
        } 

        layui.use(['layer'], function() {

            var layer = layui.layer;
            layer.closeAll();
        }); 

    },
    created: function() {
        let that = this;

        that.empInfo = J.User.Info() || that.empInfo;
 
 

        if (this.show) {


            this.GetMenus();

        } else {
            //$(".main_right").css("width", "calc(100% - 36px);")
            //直接样式写了   不用此行JS
        }


        if (this.show) {
            this.rightClass = "main_right";
            if (this.leftMenu.length > 0) {
                this.rightClass = "main_right";
            } else {
                this.rightClass = "main_right main_right_lf_none";
            }

            if (!this.showleft) {
                this.rightClass = "main_right main_right_lf_none";
            }
        } else {
            this.rightClass = "main_right main_right_none";
        }  

    },
    mounted: function() {
        let that = this;


        if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            window.addEventListener('hashchange', () => {
                let currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        }

        // if (this.site == "hr") {

        if (this.show) {
            //A路由到B路由切换了路由的情况watch监控设置值无效，因为每个独立路由之内都是独立加载的root
            this.SetMenuOn(this.$route.query.top, this.$route.query.left);
        }
        $(document).ready(function() {
            $("#main_left").css("min-height", $(window).height() - 60).niceScroll({ autohidemode: true, cursoropacitymax: 0 });




            $(".head_menu").css("max-width", $(".head_right").width() - $(".head_person_box").width() - 30)
                //$("#main_right").niceScroll({ autohidemode: true, cursoropacitymax: 0 });
                // setTimeout(() => {
                //     $("#main_left").niceScroll();
                // }, 1);

            layui.use(['form', 'layer'], function() {
                var form = layui.form;
                // var layer = layui.layer;
                // if (window.history && window.history.pushState)
                // {
                //     //history.pushState(null, null, document.URL);
                //     window.addEventListener('popstate', function ()
                //     {

                //     }, true);
                // }
                form.render(); //更新全部
            });
  
        });

 
    },
    watch: {
        '$route' () {
            layui.use(['layer'], function() {

                var layer = layui.layer;
                layer.closeAll();
            });

            //if (this.site == "hr") {

            if (this.show) {
                this.topMenu = [];
                this.leftMenu = [];
                this.GetMenus();
                //同一页面参数变化不会触发生命周期，此时监听route变化
                //watch route仅能监控同一路由下的路径变化 ；
                // 对路由变化作出响应...
                this.SetMenuOn(this.$route.query.top, this.$route.query.left);
                //location.href//浏览器内所有值

                //$("#main_left").css("min-height", $(document).height() - 60).niceScroll({ autohidemode: true, cursoropacitymax: 0 });
            }
            //this.$route.path //路由路径  不含#

            //this.$route.hash //含#的hash


            //this.$route.query //查询参数

            //this.$route.fullPath //path+查询参数

            if (this.show) {
                this.rightClass = "main_right";
                if (this.leftMenu.length > 0) {
                    this.rightClass = "main_right";
                } else {
                    this.rightClass = "main_right main_right_lf_none";
                }
                if (!this.showleft) {
                    this.rightClass = "main_right main_right_lf_none";
                }
            } else {
                this.rightClass = "main_right main_right_none";
            }
            //}
        }

    },
    methods: {
   
        GoTo: function(index, url, index2, index3) {
            let that = this;
            //返回管理或前往设置  无需index  直接跳转
            if (index == -1 && index2 == -1 && index3 == -1) {
                location.href = url;
                return false;
            }

            //顶部1级
            if (!url) {
                let item = this.topMenu[index];
                if (item.url != "") {
                    let to = item.url;
                    if (item.url.includes('personal/wagelist')) {
                        that.CommonValidPwd(item.id);
                        return;
                    }
                    location.href = J.Request.ParseUrl(to, [{ key: "top", value: item.id }]);
                } else {
                    this.$router.push({ path: "404", query: { top: item.id } }) // 
                        //location.href ="/#/page?top="+item.id;
                }
            } else {
                //2级
                let item2 = this.leftMenu[index2];
                let leftId = item2.id;
                if (index3 >= 0) {
                    let item3 = item2.childsList[index3];
                    leftId = item3.id;
                }
                let to01 = url; 
                

                location.href = J.Request.ParseUrl(to01, [{ key: "top", value: item2.parentId }, { key: "left", value: leftId }]);
            }
            //以下改变仅在同一路由下生效，切换路由后页面对象重新初始化了，则需要用生命周期监听修改赋值
            //this.onTopMenu = index;
        },

        Open: function(index2, e) {

            let that = this;
            $(document).ready(function() {
                setTimeout(() => {
                    $("#main_left").getNiceScroll().resize();

                }, 10);
            });
            let menu3 = $(e.target);
            if (!$(e.target).hasClass("menu2_item")) {
                menu3 = $(e.target).closest(".menu2_item");
            }
            //console.log(menu3);
            if (that.leftMenu[index2].open) {
                $(menu3).next("span").animate({
                    height: '0',
                    opacity: '0.1'

                }, 500, function() {
                    //$(menu3).next("span").css("display", "none");
                    that.leftMenu[index2].open = false;
                    let left2 = -1;
                    let left3 = that.onLeftMenu[1];
                    that.onLeftMenu = [left2, left3];
                });


                return;
            } else {
                for (let index = 0; index < that.leftMenu.length; index++) {
                    let item = that.leftMenu[index];
                    item.open = false;
                }
                that.leftMenu[index2].open = true;
                let left2 = index2;
                let left3 = that.onLeftMenu[1];
                this.onLeftMenu = [left2, left3];
                // $(menu3).next("span").css("height", 0);
                // $(menu3).next("span").animate({
                //     height: '200px',
                //     opacity: '1'
                // }, 1000, function() {

                // });



                // for (let index = 0; index < this.leftMenu[index2].child.length; index++)
                // {
                //     let item3 = this.leftMenu[index2].child[index];
                //     if (item3.id==this.onLeftMenu[1])
                //     {
                //         left3 = this.onLeftMenu[1]
                //     }
                // }

            }
        },
        SetMenuOn: function(topId, leftId) {
            //debugger;
            let that = this;
            //debugger;
            if (!topId) {
                topId = 0;
            }

            if (!leftId) {
                leftId = 0;
            }




            try {
                let topS = this.$route.query.topstr;
                let leftS = this.$route.query.leftstr;
                if (topId <= 0 && topS && topS.length && topS.length > 0) {
                    that.topMenu.forEach((one, index) => {
                        //debugger;
                        if (one.domStr == topS) {
                            topId = one.id;
                            this.onTopMenu = index;
                        }
                    });
                }

                if (!that.topMenu[that.onTopMenu] || !that.topMenu[that.onTopMenu].childsList) {
                    that.leftMenu = [];
                } else {
                    that.leftMenu = that.topMenu[that.onTopMenu].childsList;
                }

                if (leftId <= 0 && leftS && leftS.length && leftS.length > 0) {
                    that.leftMenu.forEach(one => {
                        if (one.childsList && one.childsList.length > 0) {

                            one.childsList.forEach(one3 => {
                                if (one3.domStr == leftS) {
                                    leftId = one3.id;
                                }
                            });
                        } else {
                            if (one.domStr == leftS) {
                                leftId = one.id;
                            }
                        }

                    });
                }
            } catch (error) {
                console.log(error);
            }


            // console.log("1:" + JSON.stringify(this.onLeftMenu));
            //顶部
            for (let index = 0; index < this.topMenu.length; index++) {
                let item = this.topMenu[index];
                if (topId > 0 && item.id == topId) {
                    this.onTopMenu = index;
                    break;
                } else if (location.href.indexOf(item.url) >= topId) {
                    this.onTopMenu = index;
                    break;
                }
            }


            if (!that.topMenu[that.onTopMenu] || !that.topMenu[that.onTopMenu].childsList) {
                that.leftMenu = [];
            } else {
                that.leftMenu = that.topMenu[that.onTopMenu].childsList;
            }
            if (this.show) {
                this.rightClass = "main_right";
                if (this.leftMenu.length > 0) {
                    this.rightClass = "main_right";
                } else {
                    this.rightClass = "main_right main_right_lf_none";
                }
                if (!this.showleft) {
                    this.rightClass = "main_right main_right_lf_none";
                }
            } else {
                this.rightClass = "main_right main_right_none";
            }

            //左侧
            for (let index = 0; index < this.leftMenu.length; index++) {
                let item = this.leftMenu[index];
                if (item.childsList && item.childsList.length > 0) {
                    for (let index3 = 0; index3 < item.childsList.length; index3++) {
                        let item3 = item.childsList[index3];
                        if (leftId && item3.id == leftId) {
                            this.onLeftMenu = [index, item3.id];
                            this.leftMenu[index].open = true;
                            break;
                        } else if (location.href.indexOf(item3.url) >= leftId) {
                            this.onLeftMenu = [index, item3.id];
                            this.leftMenu[index].open = true;
                            break;
                        }
                    }
                } else {
                    if (leftId && item.id == leftId) {
                        this.onLeftMenu = [index, "ss_" + index];
                        //this.leftMenu[index].open = true;
                        break;
                    } else if (location.href.indexOf(item.url) >= leftId) {
                        this.onLeftMenu = [index, "ss_" + index];

                        break;
                    }

                }
            }
            // this.url = location.href;
            // this.isSet = this.url.indexOf("/set/") >= 0 ? true : false;

            // if (this.leftMenu.length > 0) {
            //     if (this.isSet) {
            //         if (this.leftMenu[0].url.indexOf("/set/") < 0) {
            //             this.leftMenu[0].isSet = false;
            //         }
            //     } else {
            //         if (this.leftMenu[0].url.indexOf("/set/") >= 0) {
            //             this.leftMenu[0].isSet = true;
            //         }
            //     }
            // }

        },
        GetMenus: function() {

            //by函数接受一个成员名字符串和一个可选的次要比较函数做为参数
            //并返回一个可以用来包含该成员的对象数组进行排序的比较函数
            //当o[age] 和 p[age] 相等时，次要比较函数被用来决出高下
            var by = function(name, minor) {
                return function(o, p) {
                    var a, b;
                    if (o && p && typeof o === 'object' && typeof p === 'object') {
                        a = o[name];
                        b = p[name];
                        if (a === b) {
                            return typeof minor === 'function' ? minor(o, p) : 0;
                        }
                        if (typeof a === typeof b) {
                            return a < b ? -1 : 1;
                        }
                        return typeof a < typeof b ? -1 : 1;
                    } else {
                        thro("error");
                    }
                }
            };
            let that = this; 

            J.GetMenu(function() {
                let menus = J.Data.Storage("sys_menus");
                if (!menus || menus == null || menus.length <= 0) {
                    location.href = "/#/error/403?api=all";
                } else {
                        //emp
                        if(that.site == "emp"){
                            let pms = J.User.RolePms();
                            if(pms && pms!=null && pms.length > 0){
                                pms = pms[0];

                                for (let index = 0; index < menus.length; index++) {
                                    let obj = pms.find(f=>f.iconId == menus[index].id);
                                    if(obj){
                                        // menus[index].menu_Name = obj.iconName;

                                        if(obj.isShow == 1)
                                            that.topMenu.push(menus[index]);
                                    }else{
                                        that.topMenu.push(menus[index]);
                                    }
                                }

                                // menus = menus.sort(by('seq_No', by('id')));
                                //重新设置菜单名称
                                J.Data.Storage("sys_menus",menus);
                                
                                if (!that.$route.query.top) {
                                    console.log(that.$route.query.top, 426);
                                } else {
                                    for (let index = 0; index < that.topMenu.length; index++) {
                                        let item = that.topMenu[index];
                                        if (item.id == that.$route.query.top) {
                                            that.onTopMenu = index;
                                            break;
                                        }
                                    }
                                    if (!that.topMenu[that.onTopMenu].childsList) {
                                        that.leftMenu = [];
                                    } else {
                                        that.leftMenu = that.topMenu[that.onTopMenu].childsList.filter(f=>{
                                            let p = pms.find(c=>c.iconId == f.id);
                                            if(p)
                                                return p.isShow == 1
                                            else
                                                return f;
                                        });

                                        that.topMenu[that.onTopMenu].childsList = that.leftMenu;
                                    }

                                    // console.log(that.leftMenu);
                                }                                    
                            }
                        }else{//HR
                        //获取菜单  组织菜单
                        for (let index = 0; index < menus.length; index++) {
                            that.topMenu.push(menus[index]);
                        }
                        if (!that.$route.query.top) {
                            console.log(that.$route.query.top, 426);
                        } else {
                            for (let index = 0; index < that.topMenu.length; index++) {
                                let item = that.topMenu[index];
                                if (item.id == that.$route.query.top) {
                                    that.onTopMenu = index;
                                    break;
                                }
                            }
                            if (!menus[that.onTopMenu].childsList) {
                                that.leftMenu = [];
                            } else {
                                that.leftMenu = menus[that.onTopMenu].childsList;
                            }
                        }
                    }
                }


                that.topMenu = that.topMenu.sort(by('seq_No', by('id')));

                that.leftMenu = that.leftMenu.sort(by('seq_No', by('id')));
                console.log(that.topMenu);
                console.log(that.leftMenu);
            }); 
 

        },
        CommonValidPwd(t=4) {
            let that = this;
            J.Submit(
                api.wageApi.isHasPassword, {},
                function(res) {

                    let mobile = common.User.Info().mobile || '13522535090';
                    if (res.msg == '此用户没有二级密码') {

                        that.$router.push({
                            path: '/personal/inputpwd',
                            query: {
                                'mobile': mobile,
                                top: t,
                                left: 111111115
                            }
                        })
                    } else {
                        console.log('2222');

                        that.$router.push({
                            path: '/personal/validpwd',
                            query: {
                                'mobile': mobile,
                                top: t,
                                left: 111111115
                            }
                        })

                    }
                    return;
                })
        } 
    }
}
